import { Injectable } from '@angular/core';
import { GeoJson } from './map';

@Injectable()
export class AppService {

	messages: string[] = [];
	acceptCookies: boolean = false;
	audioStreamingUrl = "http://irratia.zintzilik.net";
	button: boolean = false;
	markers: any[] = [];
	showMap = false;
	radio = new Audio();

  constructor() {	}

	add(message: string, button:boolean = false) {
		this.messages.push(message);
		this.button=button;
	}

	addMarker(message: string, coord:any[]) {
		this.markers = coord
	}

	clearMarker() {
		this.markers = [];
	}

	playRadio() {
		this.clear()
		let streamMessage = "<div class=\"player\"><img src=\"assets/radio.png\"/><p><a href=\"https://archive.org/details/SARTAgudaRadio\" target=\"_blank\">Podcast</a></p></div>"
		this.add(streamMessage)
		this.radio.src = "https://archive.org/download/SARTAgudaRadio/SARTAguda_radio.mp3"
		this.radio.play()
	}

	clear() {
		this.messages = [];
		this.acceptCookies = true;
		this.showMap = false;
		this.radio.pause();
	}

}



// WEBPACK FOOTER //
// ./src/app/app.service.ts